import React, {useCallback, useRef, useState} from 'react';
import {Button, Overlay, Tooltip} from 'react-bootstrap';
import {Icon} from 'shared/helpers';
import {isDeviceSmall} from 'shared/helpers/DeviceSize';

interface ButtonWithPopoverProps {
    handleShow: (event: React.MouseEvent) => void;
    dynamicposition: boolean;
    disabled: boolean;
    tooltipText: number | string | JSX.Element;
    iconColor?: string;
}

export const ButtonWithPopover = ({
    handleShow,
    dynamicposition,
    disabled,
    tooltipText,
    iconColor,
}: ButtonWithPopoverProps) => {
    const isSmallDevice = isDeviceSmall();
    const target = useRef();
    const [show, setShow] = useState(false);

    const handleMouseOver = useCallback(() => {
        setShow(true);
    }, []);

    const handleMouseOut = useCallback(() => {
        setShow(false);
    }, []);

    return (
        <>
            <Button
                ref={target}
                tabIndex={-1}
                variant="link"
                onClick={handleShow}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                style={
                    dynamicposition
                        ? {width: '20px', margin: '-8px 0 0 5px'}
                        : {}
                }
                disabled={disabled}>
                <Icon iconName="More-Info.svg" color={iconColor} />
            </Button>
            <Overlay
                show={show}
                target={target.current}
                placement={isSmallDevice ? 'top' : 'right'}>
                {(props) => <Tooltip {...props}>{tooltipText}</Tooltip>}
            </Overlay>
        </>
    );
};
